import type { Module } from '@pc/core';
import { clientsModule } from '@pc/modules-clients';
import { wholesalersModule } from '@pc/modules-wholesalers';
import { vendorsModule } from '@pc/modules-vendors';
import { productsModule } from '@pc/modules-products';
import { lotManagementModule } from '@pc/modules-lot-management';
import { ordersModule } from '@pc/modules-orders';
import { contractsModule } from '@pc/modules-contracts';
import { shippingModule } from '@pc/modules-shipping';
import { fulfillmentModule } from '@pc/modules-fulfillment';
import { calendarModule } from '@pc/modules-calendar';
import { rewardsModule } from '@pc/modules-rewards';
import { reportsModule } from '@pc/modules-reports';
import { marketingModule } from '@pc/modules-marketing';
import { messagingModule } from '@pc/modules-messaging';
// Shop is shut down for now ("coming soon", 2026-06-08). Keeping the import
// commented (not deleted) so re-enabling is a one-line revert: uncomment the
// import + the `shopModule` registry entry below, and flip `SHOP_COMING_SOON`
// in apps/shop/src/main.tsx back to false.
// import { shopModule } from '@pc/modules-shop';

/**
 * Module registry for the web host.
 *
 * **This is the only file you edit when adding a module to the web app.**
 * Steps to add a module:
 *   1. Create packages/modules/<name>/ following docs/MODULE_RECIPE.md.
 *   2. Add it to apps/web/package.json dependencies as workspace:*.
 *   3. Import and append below.
 *
 * The AppShell composes nav, routes, and dashboard widgets from this array,
 * filtered by `core.org_module_flags` for the active org.
 *
 * Load order note: `contractsModule`, `shippingModule`, and
 * `fulfillmentModule` register extension slots into the orders module at
 * import time, so they must be imported AFTER ordersModule. Registration
 * is idempotent (deduped by slot id) so the array order below is the
 * only thing that matters. The fulfillment module supersedes the
 * previous `shipping.label-panel` slot on the orders detail page with
 * its own `fulfillment.shipment-panel` (which routes operators into
 * the warehouse queue + packing flow instead of buying a label inline).
 */
export const moduleRegistry: ReadonlyArray<Module> = [
  clientsModule,
  wholesalersModule,
  vendorsModule,
  productsModule,
  lotManagementModule,
  ordersModule,
  contractsModule,
  shippingModule,
  fulfillmentModule,
  calendarModule,
  rewardsModule,
  reportsModule,
  marketingModule,
  messagingModule,
  // shopModule,  // disabled for every account while the marketplace is "coming soon" (2026-06-08)
];
